import { BindingEngine } from 'aurelia-framework';
import { PieChart, XYChart } from '@amcharts/amcharts4/charts';
import { WidgetBase } from './widget-base';
import { CustomerService } from '../services/customer-service';
import { closest } from '@material/dom/ponyfill';

export abstract class ChartWidgetBase extends WidgetBase {
  constructor(element: Element, protected bindingEngine: BindingEngine, protected customerService: CustomerService) {
    super(element, bindingEngine, customerService);
  }

  chart?: HTMLElement;
  chartObject?: PieChart | XYChart;

  async detached() {
    await super.detached();
    this.chartObject?.dispose();
  }

  getChartLabelColour(labelColour?: string) {
    return labelColour ?? getComputedStyle(document.body).getPropertyValue('--dyn-default-color').trim();
  }

  isDarkTheme() {
    return (localStorage.getItem('dark-theme') ?? 'true') === 'true' && !closest(this.element, '.report-page');
  }
}
